export const STYLES = {
  APP_LAYOUT: 'flex flex-col w-full h-full pt-[33px] pb-[24px] bg-bw00',
  APP_LAYOUT_WIZARD: 'absolute inset-0 z-[9999] bg-bw00 h-screen w-screen flex flex-col fadeIn overflow-hidden',
  MAIN_CONTENT: 'flex flex-col items-center justify-center w-full bg-bw00 rounded-[8px] relative',
  INTRO_PRELOAD: 'flex flex-col items-center gap-[20px]',
  INTRO: {
    WRAPPER: 'w-[50%] h-full flex flex-col',
    HEADER_SECTION: 'w-full py-[16px] px-[24px] border-b border-bw03',
    TITLE: 'font-metricR text-[20px] text-bw08',
    BODY_WRAPPER: 'w-full flex flex-col items-center justify-center gap-[18px] grow',
    BODY_SUB_TITLE: 'font-metricR max-w-[370px] text-center text-[16px] text-bw08 leading-[20px]',
    FEE_DISCLAIMER: 'font-metricR text-center text-[14px] text-bw07',
    CTA: 'min-h-[58px] min-w-[230px] py-[17px] bg-action03 hover:bg-action04 rounded-[4px] font-metricR text-[16px] text-bw00',
    FOOTER_WRAPPER: 'w-full flex justify-center py-[16px] px-[24px] border-t border-bw03',
    FOOTER_CONTENT: 'max-w-[620px] text-center font-metricR text-[14px] text-bw06',
  },
  AMOUNT: {
    HEADER_WRAPPER: 'w-full py-[14px] px-[34px] flex items-center justify-between border-b border-bw03 relative',
    HEADER_ICON: 'w-[24px] cursor-pointer',
    HEADER_TITLE: 'font-metricR text-[20px text-bw08] leading-[30px]',
    BODY_WRAPPER: 'w-full grow flex flex-col items-center pt-[64px] relative',
    BODY_MAIN_HEADER: 'font-metricR text-[28px] text-bw08 mb-[112px]',
    CURRENCY_INPUT:
      'w-[180px] bg-bw00 h-[50px] outline-none font-metricMedium text-[25px] text-bw08 text-center placeholder-bw05 border-b caret-action03 border-action03 mb-[16px]',
    INPUT_ERROR: 'mb-[40px] text-[14px] text-red02 font-metricR',
    LIMITS_WRAPPER: 'flex items-center gap-[6px]',
    LIMIT_VALUE: 'font-metricR text-[16px] text-action03',
    LIMIT_DISCLAIMER: 'font-metricR text-[16px] text-bw07',
    FOOTER_WRAPPER: 'w-full flex items-center justify-center py-[24px] border-t border-bw03 fadeIn',
    CTA: 'text-sm text-bw00 w-[295px] rounded py-[18px] font-metricMedium w-full bg-action03 hover:bg-action04',
  },
};

export const STEPS = {
  LOADER: 1,
  INTRO: 2,
  AMOUNT: 3,
  REVIEW: 4,
  SUCCESS: 5,
  NON_ELIGIBLE: 9,
};

export const WIZARD_MODE_STEPS = [STEPS.AMOUNT, STEPS.REVIEW, STEPS.SUCCESS];

export const REVIEW_MEMO_MAX_LEN = 50;

export const MANUAL_HANDLE_ERROR_CODES = {
  INSUFFICIENT_FUNDS: 411928,
};

export const BALANCE_TITLE_MAP = {
  singleCheckLimit: 'MAIL_CHECK.AMOUNT.LIMIT_SINGLE_CHECK',
  singleLimit: 'MAIL_CHECK.AMOUNT.LIMIT_SINGLE_CHECK',
  balance: 'MAIL_CHECK.AMOUNT.LIMIT_BALANCE',
  monthlyLimit: 'MAIL_CHECK.AMOUNT.LIMIT_MONTHLY',
  dailyLimit: 'MAIL_CHECK.AMOUNT.LIMIT_DAILY',
};

export const AMOUNT_ERROR_MAP = {
  balance: 'Amount exceeded available account balance (|AMOUNT| available)',
  singleLimit: 'Amount exceeded individual transaction limit (|AMOUNT| maximum)',
  dailyLimit: 'Amount exceeded daily transaction limit (|AMOUNT| maximum)',
  singleCheckLimit: 'Amount exceeded individual transaction limit (|AMOUNT| maximum)',
  monthlyLimit: 'Amount exceeded monthly transaction limit (|AMOUNT| remaining)',
};
